import React, {Component} from "react";
import {FormattedMessage} from "react-intl";

class ProductionHeader extends Component {
    render() {
        return (
            <thead>
                <tr>
                    <th>注文番号</th>
                    <th>商品番号</th>
                    <th>お届け先住所</th>
                    <th>個数</th>
                    <th>佐川番号</th>
                    <th>操作</th>
                </tr>
            </thead>
        );
    }
}
export default ProductionHeader;



// WEBPACK FOOTER //
// ./src/components/Admin/ProductionCompletionList/ProductionHeader.js